<div class="container">
    <div class="text-center">
        <h2 class="mainHeading slide-in-left"><strong>Dumpyard Location</strong></h2>
    </div>
    <google-map class="mt-2" height="95vh" width="100%" [center]="center" [zoom]="zoom">
        <map-marker *ngFor="let marker of markers" [position]="marker.position" [icon]="marker.icon"
            [title]="marker.title" (mapClick)="onMarkerClick(marker, content)">
        </map-marker>
    </google-map>
</div>

<ng-template #content let-offcanvas>
    <div class="modal-header p-1">
      <h2 class="modal-title mt-2 p-1">Dumpyard Details</h2>
      <button type="button" class="btn-close p-2" aria-label="Close" (click)="offcanvas.dismiss()"></button>
    </div>
    <div class="offcanvas-body">
      <div class="row mb-2">
      </div>
      <div class="row mb-2">
        <div class="col-4 text-start">
          <label><strong>Company Name:</strong></label>
        </div>
        <div class="col-8 text-start">
          <span>{{ selectedDumpyard?.data.companyName }}</span>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-4 text-start">
          <label><strong>Latitude:</strong></label>
        </div>
        <div class="col-8 text-start">
          <span>{{ selectedDumpyard?.position.lat }}</span>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-4 text-start">
          <label><strong>Longitude:</strong></label>
        </div>
        <div class="col-8 text-start">
          <span>{{ selectedDumpyard?.position.lng }}</span>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-4 text-start">
          <label><strong>Phone Number:</strong></label>
        </div>
        <div class="col-8 text-start">
          <span>{{ selectedDumpyard?.data.phNo }}</span>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-4 text-start">
          <label><strong>Email:</strong></label>
        </div>
        <div class="col-8 text-start">
          <span>{{ selectedDumpyard?.data.emailAddress }}</span>
        </div>
      </div>
    </div>
  </ng-template>
  